export { default } from './index.vue';



// WEBPACK FOOTER //
// ./packages/dof-rich-text/index.js